package io.horion.cv.components.preview

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import io.horion.cv.api.datasource.motivation.ModelLetter
import io.horion.cv.uiState.LetterUiState
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div


@Composable
fun LetterPreviewPanel(
    letterUiState: LetterUiState,
    model: ModelLetter,
) {

    var zoom by remember { mutableStateOf(0.5) }

    // Barre de zoom sticky en haut
    Div(
        attrs = {
            style {
                property("position", "sticky")
                property("top", "0")
                property("z-index", "10")
                property("background-color", Colors.LightGray.toString())
                property("border-bottom", "1px solid #cccccc")
                property("width", "100%")
                property("display", "flex")
                property("justify-content", "center")
                property("align-items", "center")
                property("padding", "8px 16px")
                property("box-sizing", "border-box")
                property("gap", "10px")
            }
        }) {
        // Bouton dézoom
        Box(
            modifier = Modifier
                .size(32.px)
                .borderRadius(6.px)
                .backgroundColor(Colors.White)
                .cursor(Cursor.Pointer)
                .border(1.px, LineStyle.Solid, Colors.DarkGray)
                .onClick { if (zoom > 0.3) zoom = (zoom - 0.05).coerceAtLeast(0.3) },
            contentAlignment = Alignment.Center
        ) {
            SpanText(
                "−",
                modifier = Modifier
                    .fontSize(18.px)
                    .fontWeight(FontWeight.Bold)
                    .color(Colors.Black)
            )
        }

        // Pourcentage
        SpanText(
            "${(zoom * 100).toInt()}%",
            modifier = Modifier
                .fontSize(13.px)
                .fontFamily(INTER)
                .color(Colors.Black)
                .width(45.px)
                .styleModifier { property("text-align", "center") }
        )

        // Bouton zoom
        Box(
            modifier = Modifier
                .size(32.px)
                .borderRadius(6.px)
                .backgroundColor(Colors.White)
                .cursor(Cursor.Pointer)
                .border(1.px, LineStyle.Solid, Colors.DarkGray)
                .onClick { if (zoom < 1.0) zoom = (zoom + 0.05).coerceAtMost(1.0) },
            contentAlignment = Alignment.Center
        ) {
            SpanText(
                "+",
                modifier = Modifier
                    .fontSize(18.px)
                    .fontWeight(FontWeight.Bold)
                    .color(Colors.Black)
            )
        }

        // Bouton reset
        Box(
            modifier = Modifier
                .borderRadius(6.px)
                .backgroundColor(Colors.White)
                .cursor(Cursor.Pointer)
                .border(1.px, LineStyle.Solid, Colors.DarkGray)
                .padding(topBottom = 6.px, leftRight = 10.px)
                .onClick { zoom = 0.5 },
            contentAlignment = Alignment.Center
        ) {
            SpanText(
                "Réinitialiser",
                modifier = Modifier
                    .fontSize(12.px)
                    .fontFamily(INTER)
                    .color(Colors.Black)
            )
        }
    }
    // Zone LETTRE scalée

    val letterNaturalHeight = 1123
    val scaledHeight = (letterNaturalHeight * zoom).toInt()
    val marginBottom = scaledHeight - letterNaturalHeight

    Div(
        attrs = {
            style {
                property("padding", "20px 0")
                property("display", "flex")
                property("justify-content", "center")
                property("width", "100%")
            }
        }) {
        Div(
            attrs = {
                style {
                    property("transform", "scale($zoom)")
                    property("transform-origin", "top center")
                    property("margin-bottom", "${marginBottom}px")
                    property("filter", "drop-shadow(0 4px 24px rgba(0,0,0,0.18))")
                }
            }) {
            when (model) {
                ModelLetter.ADVANCE -> LetterAdvancePreview(letterUiState)
                ModelLetter.MODERN -> LetterModernPreview(letterUiState)
                ModelLetter.PROFESSIONAL -> LetterProfessionalPreview(letterUiState)
                ModelLetter.SIMPLE -> LetterSimplePreview(letterUiState)
                ModelLetter.ENGLISH -> LetterEnglishPreview(letterUiState)
                ModelLetter.FRENCH -> LetterFrenchPreview(letterUiState)
                else -> LetterSimplePreview(letterUiState)
            }
        }
    }
}